/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable max-len */
/* eslint-disable react/sort-comp */
/* eslint-disable react/no-did-update-set-state */
import React, { PureComponent, lazy, Suspense, memo } from 'react';
import PropTypes from 'prop-types';
import AWS from 'aws-sdk';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import moment from 'utils/moment';
import { getField, getS3Region } from '../../../../utils/helpers';
import styles from './badging.module.scss';
import Panel from '../../../../components/panel';
import Button from '../../../../components/button/button';
import { GetFileName, S3Uploads } from '../../../services';
import Loading from '../../../../components/loading';
import { getSchema, initiateApplication, clearApplicationDetails, getApplication, badgeReapply, getAccessAreas, renewApplication } from '../../redux/actions';
import SectionHeader from '../../../../components/sectionHeader';
import HeaderBack from '../../../../components/headerBack';
import icon from '../../../../icons/badging.png';
import { getBackendId } from '../../../../constants/apiEnv';
import Auth from '../../../../utils/Auth';

const SignatoryField = lazy(() => import('./SignatoryField/SignatoryField'));

class SignatoryApplication extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      info: { attachments_listA: [], attachments_listB: [], attachments_listC: [], feet: '', inches: '', access_area: '', sub_access_areas: '' },
      answers: {},
      requiredMap: {},
      fieldErrors: {
        first_name: true,
        last_name: true,
        email: true,
        phone_number: true,
        signature: false,
        employer: false,
        attachmentslist_a: false,
        attachmentslist_b: false,
        attachmentslist_c: false
      },
      listAValues: [],
      listBValues: [],
      listCValues: [],
      requiredAttachments: {},
      requiredAttachmentsErrors: {},
      signatureFields: [],
      signatoryRequiredMap: {},
      signatoryFieldErrors: {},
      removedAttachments_A: [],
      removedAttachments_B: [],
      removedAttachments_C: [],
      response: {
        nation_of_citizenship: { value: 'US', label: 'United States' }
      },
      signatoryResponse: {},
      showFormErrors: false,
      loadingStatus: false,
      emsg: false,
      reOpenId: this.props?.match?.params?.id,
      reOpenData: {},
      listAError: false,
      listBError: false,
      listAMessage: '',
      listBMessage: '',
      listCMessage: '',
      applicantAcknowldgementMessage: '',
      dateError: false,
      accessAreaError: false
    };
  }

  async componentDidMount() {
    const { actionFetchSchema, actionReopenDetail, actionFetchPrivileges } = this.props;
    actionFetchSchema();
    actionFetchPrivileges();
    if (this.state.reOpenId !== undefined) {
      actionReopenDetail(this.props?.match?.params?.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { schema, user, application, fetchApplicationAction, action } = this.props;
    const { response, reOpenData, signatoryResponse } = this.state;
    if (action.success === true && prevProps.action.success!== action.success) {
      this.getListAMessageData(schema?.settings?.list_a_documents);
      this.getListBMessageData(schema?.settings?.list_b_documents);
      this.getListCMessageData(schema?.settings?.list_c_documents);
      this.getApplicantAcknowldgementMessageData(schema?.settings?.applicant_acknowledgement);
    }
    if (prevProps.fetchApplicationAction !==fetchApplicationAction&& fetchApplicationAction.success=== true) {
      this.setState({
        reOpenData: application
      });
    }
    if (prevState.reOpenData !== reOpenData && reOpenData!== undefined) {
      let thefieldErrors = {};
      const bool = true;
      let signatoryErrors = {};
      const bool1 = true;
      if (reOpenData.response) {
        Object.entries(reOpenData.response).forEach(([key, value]) => {
          thefieldErrors = {
            ...thefieldErrors,
            [key]: value ? !bool : bool
          };
        });
      }
      if (reOpenData?.signatory_response) {
        if (reOpenData.signatory_response) {
          Object.entries(reOpenData.signatory_response).forEach(([key, value]) => {
            signatoryErrors = {
              ...signatoryErrors,
              [key]: value ? !bool1 : bool1
            };
          });
        }
      }

      const attachmentslistA = getField(reOpenData?.answer_schema?.fields, 'attachmentslist_a');
      const attachmentslistB = getField(reOpenData?.answer_schema?.fields, 'attachmentslist_b');
      const attachmentslistC = getField(reOpenData?.answer_schema?.fields, 'attachmentslist_c');

      const listAValues = Object.keys(attachmentslistA?.settings?.req_docs|| {})?.map(e => ({ key: `${e}`, value: attachmentslistA?.settings?.req_docs?.[e] }));
      const listBValues = Object.keys(attachmentslistB?.settings?.req_docs|| {})?.map(e => ({ key: `${e}`, value: attachmentslistB?.settings?.req_docs?.[e] }));
      const listCValues = Object.keys(attachmentslistC?.settings?.req_docs|| {})?.map(e => ({ key: `${e}`, value: attachmentslistC?.settings?.req_docs?.[e] }));

        let reqAttachments = {};
        let reqAttachmentsErrors = {};

        const updateReqAttachments = () => {
          const attachments_listA = {};
          const attachments_listB = {};
          const attachments_listC = {};

          let dateFormat = localStorage.getItem('dateFormat') || 'DD/MM/YYYY';

          const listAErrors = {};
          const listBErrors = {};
          const listCErrors = {};
          const isBadgeExpired = reOpenData?.status === 7;

          if (attachmentslistA?.settings?.add_req_docs) {
          Object.keys(reOpenData?.forms_of_identification?.attachments_listA || {}).forEach((eachRow) => {
            const { file_name = '', attachment = [], expiry_date = '' } = reOpenData?.forms_of_identification?.attachments_listA?.[eachRow] || {};


            attachments_listA[eachRow] = {
              file_name: !isBadgeExpired ?file_name?.key : '',
              ...(attachmentslistA?.settings?.add_expiration && (!isBadgeExpired ?{ expiry_date } :{ expiry_date: moment(new Date()).format(dateFormat) })),
              attachment: !isBadgeExpired ? reOpenData?.attachments_listA.filter(each => attachment.includes(each.attachment_id)) :[]
            };

            listAErrors[eachRow] = {
              file_name: attachmentslistA.required?(isBadgeExpired? true: !Object.keys(file_name || {}).length > 0): false,
              ...(attachmentslistA?.settings?.add_expiration && { expiry_date: attachmentslistA.required ? (isBadgeExpired ? true :!expiry_date?.length>0) : false }),
              attachment: attachmentslistA.required ? (isBadgeExpired ? true :!attachment?.length>0) : false
            };
          });
        }
        if (attachmentslistB?.settings?.add_req_docs) {
          Object.keys(reOpenData?.forms_of_identification?.attachments_listB || {}).forEach((eachRow) => {
            const { file_name = '', attachment = [], expiry_date = '' } = reOpenData?.forms_of_identification?.attachments_listB?.[eachRow] || {};


            attachments_listB[eachRow] = {
              file_name: !isBadgeExpired ?file_name?.key : '',
              ...(attachmentslistB?.settings?.add_expiration && (!isBadgeExpired ?{ expiry_date } :{ expiry_date: moment(new Date()).format(dateFormat) })),
              attachment: !isBadgeExpired ? reOpenData?.attachments_listB.filter(each => attachment.includes(each.attachment_id)) :[]
            };

            listBErrors[eachRow] = {
              file_name: attachmentslistB.required?(isBadgeExpired? true: !Object.keys(file_name || {}).length > 0): false,
              ...(attachmentslistB?.settings?.add_expiration && { expiry_date: attachments_listB.required ? (isBadgeExpired ? true :!expiry_date?.length>0) : false }),
              attachment: attachmentslistB.required ? (isBadgeExpired ? true :!attachment?.length>0) : false
            };
          });
        }

        if (attachmentslistC?.settings?.add_req_docs) {
          Object.keys(reOpenData?.forms_of_identification?.attachments_listC || {}).forEach((eachRow) => {
            const { file_name = '', attachment = [], expiry_date = '' } = reOpenData?.forms_of_identification?.attachments_listC?.[eachRow] || {};


            attachments_listC[eachRow] = {
              file_name: !isBadgeExpired ?file_name?.key : '',
              ...(attachmentslistC?.settings?.add_expiration && (!isBadgeExpired ?{ expiry_date } :{ expiry_date: moment(new Date()).format(dateFormat) })),
              attachment: !isBadgeExpired ? reOpenData?.attachments_listC.filter(each => attachment.includes(each.attachment_id)) :[]
            };

            listCErrors[eachRow] = {
              file_name: attachmentslistC.required?(isBadgeExpired? true: !Object.keys(file_name || {}).length > 0): false,
              ...(attachmentslistC?.settings?.add_expiration && { expiry_date: attachments_listC.required ? (isBadgeExpired ? true :!expiry_date?.length>0) : false }),
              attachment: attachmentslistC.required ? (isBadgeExpired ? true :!attachment?.length>0) : false
            };
          });
        }

          reqAttachments.attachments_listA = attachments_listA;
          reqAttachments.attachments_listB = attachments_listB;
          reqAttachments.attachments_listC = attachments_listC;
          reqAttachmentsErrors.attachments_listA = listAErrors;
          reqAttachmentsErrors.attachments_listB = listBErrors;
          reqAttachmentsErrors.attachments_listC = listCErrors;

          return reqAttachments;
        };

        updateReqAttachments();
        let normalizedAccessArea = [];
        if (typeof application.access_area === 'string' && application.access_area.trim() !== '') {
            normalizedAccessArea = application.access_area
            .split(',')?.map(a => ({ label: a.trim(), value: a.trim() }));
        } else if (Array.isArray(application.access_area)) {
          normalizedAccessArea = application.access_area?.map(a => (typeof a === 'string' ? { label: a, value: a } : a));
        }

        let normalizedSubAccessArea = [];
        if (typeof application.sub_access_areas === 'string' && application.sub_access_areas.trim() !== '') {
            normalizedSubAccessArea = application.sub_access_areas
            .split(',')?.map(a => ({ label: a.trim(), value: a.trim() }));
        } else if (Array.isArray(application.sub_access_areas)) {
          normalizedSubAccessArea = application.sub_access_areas?.map(a => (typeof a === 'string' ? { label: a, value: a } : a));
        }

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        info: {
          ...this.state.info,
          first_name: reOpenData.first_name,
          last_name: reOpenData.last_name,
          suffix: reOpenData.suffix,
          email: reOpenData.email,
          phone_number: reOpenData.phone_number,
          attachments_listA: reOpenData.attachments_listA,
          attachments_listB: reOpenData.attachments_listB,
          attachments_listC: reOpenData.attachments_listC,
          feet: reOpenData.response.height.split('\'')[0],
          inches: reOpenData.response.height.split('\'')[1],
          access_area: normalizedAccessArea,
          sub_access_areas: normalizedSubAccessArea
        },
        response: {
          ...reOpenData?.response,
          nation_of_citizenship: reOpenData.response?.nation_of_citizenship ? reOpenData.response?.nation_of_citizenship : { value: 'US', label: 'United States' },
          street: reOpenData?.response?.street,
          social_security_number: reOpenData.response?.social_security_number,
          feet: reOpenData.response.height.split('\'')[0],
          inches: reOpenData.response.height.split('\'')[1],
          place_of_birth: reOpenData?.response?.place_of_birth
        },
        additional_info: [
          {
            multipleRemarks: reOpenData && reOpenData?.additional_info && reOpenData.additional_info[0]?.multipleRemarks ? reOpenData && reOpenData?.additional_info && reOpenData.additional_info[0]?.multipleRemarks : {},
            felonyInvolvingRemarks: reOpenData && reOpenData?.additional_info && reOpenData.additional_info[0]?.felonyInvolvingRemarks ? reOpenData && reOpenData?.additional_info && reOpenData.additional_info[0]?.felonyInvolvingRemarks : {},
            noneCheckbox: reOpenData && reOpenData?.additional_info && reOpenData.additional_info[0]?.noneCheckbox ? reOpenData && reOpenData?.additional_info && reOpenData.additional_info[0]?.noneCheckbox : false,
            agreements: {
              door: reOpenData && reOpenData?.additional_info && reOpenData?.additional_info[0]?.agreements && reOpenData?.additional_info[0]?.agreements?.door ? reOpenData && reOpenData?.additional_info && reOpenData?.additional_info[0]?.agreements && reOpenData?.additional_info[0]?.agreements?.door : '',
              airside: reOpenData && reOpenData?.additional_info && reOpenData?.additional_info[0]?.agreements && reOpenData?.additional_info[0]?.agreements?.airside ? reOpenData && reOpenData?.additional_info && reOpenData?.additional_info[0]?.agreements && reOpenData?.additional_info[0]?.agreements?.airside : '',
              rules: reOpenData && reOpenData?.additional_info && reOpenData?.additional_info[0]?.agreements && reOpenData?.additional_info[0]?.agreements?.rules ? reOpenData && reOpenData?.additional_info && reOpenData?.additional_info[0]?.agreements && reOpenData?.additional_info[0]?.agreements?.rules : ''
            },
            checkedMultipleValues: reOpenData && reOpenData?.additional_info && reOpenData.additional_info[0]?.checkedMultipleValues ? reOpenData && reOpenData?.additional_info && reOpenData.additional_info[0]?.checkedMultipleValues : {},
            felonyCheckedValues: reOpenData && reOpenData?.additional_info && reOpenData.additional_info[0]?.felonyCheckedValues ? reOpenData && reOpenData?.additional_info && reOpenData.additional_info[0]?.felonyCheckedValues : {}
          }
        ],
        fields: reOpenData.answer_schema.fields,
        fieldErrors: {
          first_name: reOpenData?.first_name ? false:true,
          last_name: reOpenData?.last_name ? false:true,
          email: reOpenData?.email ? false:true,
          phone_number: reOpenData?.phone_number ? false:true,
          employer: reOpenData.company_name ? false : true,
          attachmentslist_a: false,
          attachmentslist_b: false,
          attachmentslist_c: false,
          ...thefieldErrors
        },
        listAValues,
        listBValues,
        listCValues,
        requiredAttachmentsErrors: reqAttachmentsErrors,
        requiredAttachments: reqAttachments,
        signatoryResponse: reOpenData?.signatory_response,
        signatoryFieldErrors: {
          ...signatoryErrors
        }
      });
    } else {
    try {
      let requiredMap = {};
      let fieldErrors = {};
      const conditionalFields = {};
      const attachmentFields = [];
      const signatureFields = [];
      const fields = schema?.schema?.schema?.fields;

      const attachmentslistA = getField(fields, 'attachmentslist_a');
      const attachmentslistB = getField(fields, 'attachmentslist_b');
      const attachmentslistC = getField(fields, 'attachmentslist_c');

      const minofDocsA = attachmentslistA?.settings?.min_no_of_reqDocs;
      const minofDocsB = attachmentslistB?.settings?.min_no_of_reqDocs;
      const minofDocsC = attachmentslistC?.settings?.min_no_of_reqDocs;
      const listAValues = Object.keys(attachmentslistA?.settings?.req_docs|| {})?.map(e => ({ key: `${e}`, value: attachmentslistA?.settings?.req_docs?.[e] }));
      const listBValues = Object.keys(attachmentslistB?.settings?.req_docs|| {})?.map(e => ({ key: `${e}`, value: attachmentslistB?.settings?.req_docs?.[e] }));
      const listCValues = Object.keys(attachmentslistC?.settings?.req_docs|| {})?.map(e => ({ key: `${e}`, value: attachmentslistC?.settings?.req_docs?.[e] }));

      let reqAttachments = {};
      let reqAttachmentsErrors = {};

      const updateReqAttachments = () => {
        const attachments_listA = {};
        const attachments_listB = {};
        const attachments_listC = {};
        const listAErrors = {};
        const listBErrors = {};
        const listCErrors = {};


        if (attachmentslistA?.settings?.add_req_docs) {
        for (let i = 0; i < minofDocsA; i++) {
          const rowKey = `row_${i}`;
          attachments_listA[rowKey] = {
            file_name: '',
            ...(attachmentslistA?.settings?.add_expiration && { expiry_date: '' }),
            attachment: []
          };

          listAErrors[rowKey] = {
            file_name: attachmentslistA.required,
              ...(attachmentslistA?.settings?.add_expiration && { expiry_date: attachmentslistA.required }),
              attachment: attachmentslistA.required
            };
        }
}

        if (attachmentslistB?.settings?.add_req_docs) {
        for (let i = 0; i < minofDocsB; i++) {
          const rowKey = `row_${i}`;

          attachments_listB[rowKey] = {
            file_name: '',
            ...(attachmentslistB?.settings?.add_expiration && { expiry_date: '' }),
            attachment: []
          };

          listBErrors[rowKey] = {
            file_name: attachmentslistB.required,
            ...(attachmentslistB?.settings?.add_expiration && { expiry_date: attachmentslistB.required }),
            attachment: attachmentslistB.required
          };
        }
      }

        if (attachmentslistC?.settings?.add_req_docs) {
        for (let i = 0; i < minofDocsC; i++) {
          const rowKey = `row_${i}`;

          attachments_listC[rowKey] = {
            file_name: '',
            ...(attachmentslistC?.settings?.add_expiration && { expiry_date: '' }),
            attachment: []
          };

          listCErrors[rowKey] = {
            file_name: attachmentslistC.required,
            ...(attachmentslistC?.settings?.add_expiration && { expiry_date: attachmentslistC.required }),
            attachment: attachmentslistC.required
          };
        }
      }


        reqAttachments.attachments_listA = attachments_listA;
        reqAttachments.attachments_listB = attachments_listB;
        reqAttachments.attachments_listC = attachments_listC;

        reqAttachmentsErrors.attachments_listA = listAErrors;
        reqAttachmentsErrors.attachments_listB = listBErrors;
        reqAttachmentsErrors.attachments_listC = listCErrors;

        return reqAttachments;
      };

    updateReqAttachments();

      if (fields?.length > 0) {
        fields.forEach((detailField) => {
          const isDisabled = detailField.isDisabled || detailField?.disable_for_portal;
          if (
            detailField.type !== 'dataSource'
            && detailField.type !== 'dataSourceMultiselect'
            && detailField.type !== 'header'
            && detailField.type !== 'attachments'
          ) {
            requiredMap = {
              ...requiredMap,
              [detailField.id]: isDisabled ? false : detailField.required,
              signature: false
            };
            if (!detailField.conditional) {
              fieldErrors = {
                ...this.state.fieldErrors,
                ...fieldErrors,
                [detailField.id]: isDisabled ? false : detailField.required,
                check1: false,
                check2: false,
                check3: false,
                signature: false,
                employer: false,
                nation_of_citizenship: response?.nation_of_citizenship?.value !== 'US',
                passport: response?.nation_of_citizenship?.value !== 'US',
                passport_country: response?.nation_of_citizenship?.value !== 'US',
                alien_registration_number: response?.nation_of_citizenship?.value !== 'US',
                attachmentslist_a: (!attachmentslistA?.isDisabled && !attachmentslistA?.settings?.add_req_docs)? (attachmentslistA?.required === undefined ? false : attachmentslistA?.required) : false,
                attachmentslist_b: (!attachmentslistB?.isDisabled && !attachmentslistB?.settings?.add_req_docs) ? (attachmentslistB?.required === undefined ? false : attachmentslistB?.required) :false,
                attachmentslist_c: (!attachmentslistC?.isDisabled && !attachmentslistC?.settings?.add_req_docs) ? (attachmentslistC?.required === undefined ? false : attachmentslistC?.required) :false
              };
            } else if (!isDisabled) {
                const parentKey = detailField?.conditional_field?.key;
                conditionalFields[parentKey] = [
                  ...(conditionalFields[parentKey] || []),
                  detailField
                ];
              } else {
              fieldErrors = {
                  ...fieldErrors,
                  [detailField.id]: false
                };
            }
          }
          if (detailField.type === 'attachments') attachmentFields.push(detailField.id);
          if (detailField.type === 'signature') signatureFields.push(detailField.id);
          const employerType = fields?.filter(fil => fil.id === 'employer');
          if (prevProps.schema !== schema) {
            fieldErrors = { ...fieldErrors,
              attachmentslist_a: (!attachmentslistA?.isDisabled && !attachmentslistA?.settings?.add_req_docs)? (attachmentslistA?.required === undefined ? false : attachmentslistA?.required) :false,
              attachmentslist_b: (!attachmentslistB?.isDisabled && !attachmentslistB?.settings?.add_req_docs) ? (attachmentslistB?.required === undefined ? false : attachmentslistB?.required) :false,
              attachmentslist_c: (!attachmentslistC?.isDisabled && !attachmentslistC?.settings?.add_req_docs) ? (attachmentslistC?.required === undefined ? false : attachmentslistC?.required) :false };
          this.setState({
            fields,
            requiredMap,
            fieldErrors,
            listAValues,
            listBValues,
            listCValues,
            requiredAttachmentsErrors: reqAttachmentsErrors,
            requiredAttachments: reqAttachments,
            loadingStatus: false,
            attachmentFields,
            signatureFields,
            conditionalFields,
            response: {
              ...response,
              employer: employerType && Object.keys(employerType).length > 0 && employerType[0].type === 'select'
              ? { value: user.current_tenant?.id, label: user.current_tenant?.name } : user?.current_tenant?.name,
              nation_of_citizenship: { value: 'US', label: 'United States' }
            }
          });
        }
        });
      }
      let signatoryRequiredMap = {};
      let signatoryFieldErrors = {};
      const signatoryConditionalFields = {};
      const signatoryAttachmentFields = [];
      const signatorySignatureFields = [];
      let signatoryCustomFields = schema?.signatory_fields_schema?.schema?.fields;
      if (signatoryCustomFields?.length > 0) {
        signatoryCustomFields.forEach((signatoryDetailField) => {
          if (
            signatoryDetailField.type !== 'dataSource'
            && signatoryDetailField.type !== 'dataSourceMultiselect'
            && signatoryDetailField.type !== 'header'
            && signatoryDetailField.type !== 'attachments'
          ) {
            signatoryRequiredMap = {
              ...signatoryRequiredMap,
              [signatoryDetailField.id]: signatoryDetailField.isDisabled? false : signatoryDetailField.required
            };
            if (!signatoryDetailField.conditional) {
              signatoryFieldErrors = {
                ...this.state.signatoryFieldErrors,
                ...signatoryFieldErrors,
                [signatoryDetailField.id]: signatoryDetailField.isDisabled? false : signatoryDetailField.required
              };
            } else {
              signatoryConditionalFields[
                signatoryDetailField?.conditional_field?.key
              ] = signatoryDetailField;
            }
          }
          if (signatoryDetailField.type === 'attachments') signatoryAttachmentFields.push(signatoryDetailField.id);
          if (signatoryDetailField.type === 'signature') signatorySignatureFields.push(signatoryDetailField.id);
          if (prevProps.schema !== schema) {
            this.setState({
              signatoryCustomFields,
              signatoryRequiredMap,
              signatoryFieldErrors,
              loadingStatus: false,
              signatoryConditionalFields,
              signatoryAttachmentFields,
              signatorySignatureFields,
              signatoryResponse: {
                ...signatoryResponse
              }
            });
          }
        });
      }
      const {
        history, saveAction, errormsg, ReApplicationAction, RenewalApplicationAction
      } = this.props;
      if ((saveAction.success === true && prevProps.saveAction.success !== saveAction.success) || (RenewalApplicationAction.success === true && prevProps.RenewalApplicationAction.success !== RenewalApplicationAction.success) || (ReApplicationAction.success === true && prevProps.ReApplicationAction.success !== ReApplicationAction.success)) {
        history.push('/badging/List');
      }
      if (saveAction.error === true && prevProps.saveAction.error !== saveAction.error) {
        this.setState({ emsg: errormsg.detail, loadingStatus: false });
      }
    } catch (error) {
      const message = 'There was a problem while retrieving the form';
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false
      });
    }
  }
  }

  componentWillUnmount() {
    const { clearApplicationList } = this.props;
    clearApplicationList();
  }


  getListAMessageData = async (fileName) => {
    const backend = getBackendId();
    const key = `cognito-idp.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`;
    AWS.config.update({
      region: process.env.REACT_APP_REGION,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        Logins: {
          [key]: Auth.getInstance().getIDToken()
        }
      })
    });
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });
    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${backend}-attachments/conditions/badging`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ listAMessage: info });
    }).catch(() => {
      this.setState({ listAMessage: '' });
    });
  };

  getListBMessageData = async (fileName) => {
    const backend = getBackendId();
    const key = `cognito-idp.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`;
    AWS.config.update({
      region: process.env.REACT_APP_REGION,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        Logins: {
          [key]: Auth.getInstance().getIDToken()
        }
      })
    });
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });
    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${backend}-attachments/conditions/badging`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ listBMessage: info });
    }).catch(() => {
      this.setState({ listBMessage: '' });
    });
  };

  getListCMessageData = async (fileName) => {
    const backend = getBackendId();
    const key = `cognito-idp.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`;
    AWS.config.update({
      region: process.env.REACT_APP_REGION,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        Logins: {
          [key]: Auth.getInstance().getIDToken()
        }
      })
    });
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01'
    });
    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${backend}-attachments/conditions/badging`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ listCMessage: info });
    }).catch(() => {
      this.setState({ listCMessage: '' });
    });
  };

  getApplicantAcknowldgementMessageData = async (fileName) => {
    const backend = getBackendId();
    const key = `cognito-idp.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`;
    AWS.config.update({
      region: process.env.REACT_APP_REGION,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        Logins: {
          [key]: Auth.getInstance().getIDToken()
        }
      })
    });
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });
    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${backend}-attachments/conditions/badging`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ applicantAcknowldgementMessage: info });
    }).catch(() => {
      this.setState({ applicantAcknowldgementMessage: '' });
    });
  };

  handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id && e.name) {
        oldAttachments.push(e.name);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await GetFileName.getUploadFileName(newAttachments?.length);
    }
    if (fileIds) {
      await S3Uploads.uploadFiles(
        newAttachments,
        fileIds.filename,
        entity || 'badgingCustomAttachments'
      ).then(() => {
        fileIds.filename.forEach((id) => {
          attachmentIds.push(id.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }

    return attachmentIds;
  }


  handleAnswerChanged = (section, answer, fieldId, list, row) => {
    const { schema } = this.props;
    const { response, fieldErrors, info, conditionalFields, requiredAttachments } = this.state;
    const getAttachment = id => schema?.schema?.schema?.fields?.find(f => f.id === id)?.settings;
    const a_attachment = getAttachment('attachmentslist_a');
    const b_attachment = getAttachment('attachmentslist_b');
    const c_attachment = getAttachment('attachmentslist_c');
    const streetType = schema?.schema?.schema?.fields?.find(f => f.id === 'street');
    if (fieldId === 'attachments_listA' && list) {
      this.setState(prevState => ({
        ...prevState,
        fieldErrors: {
          ...prevState.fieldErrors,
          attachmentslist_a: !answer.length>0
        }
      }));
    }
    if (fieldId === 'attachments_listB' && list) {
      this.setState(prevState => ({
        ...prevState,
        fieldErrors: {
          ...prevState.fieldErrors,
          attachmentslist_b: !answer.length>0
        }
      }));
    }
        if (fieldId === 'attachments_listC' && list) {
      this.setState(prevState => ({
        ...prevState,
        fieldErrors: {
          ...prevState.fieldErrors,
          attachmentslist_c: !answer.length>0
        }
      }));
    }
    if (fieldId === 'access_area') {
      this.setState({
        info: {
          ...info,
          access_area: Array.isArray(answer) ? answer : [answer],
          sub_access_areas: ''
        },
        accessAreaError: false
      });
    }
    if (fieldId === 'street'&& streetType?.type === 'address') {
      this.setState({
        response: {
          ...response,
          street: answer.street,
          state: answer.state,
          city: answer.city,
          zip: answer.zip,
          country: answer.country
          ? { label: answer.country?.label, value: answer.country?.value }
          : response.country
        },
        fieldErrors: {
          ...fieldErrors,
          street: !answer.street,
          city: !answer.city,
          state: !answer.state,
          country: answer.country
          ? !(answer.country?.label && answer.country?.value)
          : fieldErrors.country,
          zip: !answer.zip
        }
      });
    }
    if (fieldId === 'feet') {
      this.setState({
        info: {
          ...info,
          feet: answer
        },
        response: {
          ...response,
          height: answer
        }
      });
    }
    if (fieldId === 'inches') {
      this.setState({
        info: {
          ...info,
          inches: answer
        },
        response: {
          ...response,
          height: `${info?.feet}'${answer}`
        },
        fieldErrors: {
          ...fieldErrors,
          height: false
        }
      });
    }
    if (fieldId === 'employer_address') {
      this.setState({
        response: {
          ...response,
          employer_address: answer.fulladdress
        }
      });
    }
    if (section === 'requiredAttachments') {
      const attachmentsMap = {
        attachments_listA: a_attachment,
        attachments_listB: b_attachment,
        attachments_listC: c_attachment
      };
      const currentAttachment = attachmentsMap[list];
      // call solve once — ensure we always pass an array and a string
      const valid = this.solve(
        currentAttachment?.req_docs_for_validation ?? [], // array expected
        String(answer ?? '') // normalize answer
      );
      let error = false;
      let attachmentError = false;
      if (fieldId !== 'attachment') {
      const hasValue = String(answer ?? '').trim() !== '';
      const selectedCheck = hasValue && String(answer) === String(valid?.key);
      error = selectedCheck ? false : !hasValue;
      attachmentError = selectedCheck ? false : !!requiredAttachments?.[list]?.[row]?.attachment;
      } else if (answer?.length>0) {
        error = false;
      } else {
        error = true;
      }
      // update nested state immutably and log errors after update
      this.setState((prevState) => {
        const newRequiredAttachments = {
          ...prevState.requiredAttachments,
          [list]: {
            ...prevState.requiredAttachments?.[list],
            [row]: {
              ...prevState.requiredAttachments?.[list]?.[row],
              [fieldId]: answer
            }
          }
        };
        const newRequiredAttachmentsErrors = {
          ...prevState.requiredAttachmentsErrors,
          [list]: {
            ...prevState.requiredAttachmentsErrors?.[list],
            [row]: {
              ...prevState.requiredAttachmentsErrors?.[list]?.[row],
              attachment: attachmentError,
              [fieldId]: error
            }
          }
        };
        return {
          ...prevState,
          requiredAttachments: newRequiredAttachments,
          requiredAttachmentsErrors: newRequiredAttachmentsErrors
        };
      });
    }

    if (section !== 'additional_info' && section !== 'requiredAttachments') {
      this.setState(prevState => ({
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }
     // HANDLE CONDITIONAL FIELDS WITH FIELD ERRORS
     if (conditionalFields?.[fieldId]?.length) {
      conditionalFields[fieldId].forEach((item) => {
      const conditionValues = item?.conditional_values;
      let fieldValue = answer;
      let enabelCondition = false;
      if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
      enabelCondition = conditionValues.some(value => fieldValue === value?.value);
      if (item.required) {
        const currentValue = this.state?.[section]?.[item?.id];
        this.handleFieldErrorChanged(
          section,
          item.id,
          enabelCondition ? !currentValue : false
        );
      }
      if (item?.type !== 'header') {
        if (enabelCondition) {
          const initialValue = this.state?.[section]?.[item.id]
          ?? (item?.type === 'boolean' ? false : '');
          this.setState(prevState => ({
            [section]: {
              ...prevState[section],
              [fieldId]: answer,
              [item.id]: initialValue
            },
            fieldErrors: {
            ...prevState.fieldErrors,
            [item.id]: item.required && !initialValue
          }
          }));
        } else {
          this.setState(prevState => ({
            [section]: {
              ...prevState[section],
              [fieldId]: answer,
              [item.id]: item?.type === 'boolean' ? false : ''
            },
            fieldErrors: {
              ...prevState.fieldErrors,
              [item.id]: false
            }
          }));
          if (item?.conditional) this.handleAnswerChanged('', item.id);
        }
      }
      return item;
    });
  }
  if (section !== 'requiredAttachments') {
    this.setState(prevState => ({
      [section]: {
        ...prevState[section],
        [fieldId]: answer
      }
    }));
}
  };

  handleFieldErrorChanged = (section, id, value) => {
    if (section !== 'signatory_answers') {
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  } else {
    this.setState(prevState => ({
    signatoryFieldErrors: {
      ...prevState.signatoryFieldErrors,
      [id]: value
    }
  }));
  }
  };

  handleSearchForUser = (value) => {
    const { actionSearchUser } = this.props;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      actionSearchUser(value);
    }, 300);
  };

  handleDropListA = (dropped, required) => {
    const { info } = this.state;
    this.handleAnswerChanged(
      'info',
      [...info.attachments_listA, ...dropped],
      'attachments_listA',
      required
    );
  };

  handleDropListB = (dropped, required) => {
    const { info } = this.state;
    this.handleAnswerChanged(
      'info',
      [...info.attachments_listB, ...dropped],
      'attachments_listB',
      required
    );
  };

    handleDropListC = (dropped, required) => {
      const { info } = this.state;
      this.handleAnswerChanged(
        'info',
        [...info.attachments_listC, ...dropped],
        'attachments_listC',
        required
      );
    };

  handleDropList = (dropped, list, row) => {
    this.handleAnswerChanged('requiredAttachments', [...dropped], 'attachment', list, row);
  };

  solve = (request_validation, answer) => {
    const keys = Array.isArray(request_validation)
      ? request_validation.map(String)
      : [];
    const key = keys.includes(String(answer)) ? String(answer) : undefined;
    return { key };
  };

  handleRemoveImage = (r, list, row, field) => {
    const { removedAttachments_A, removedAttachments_B, requiredAttachments, removedAttachments_C } = this.state;
  const res = requiredAttachments?.[list]?.[row]?.[field].filter(e => e !== r);
  this.handleAnswerChanged('requiredAttachments', res, 'attachment', list, row);
  if (list === 'attachments_listA') {
    removedAttachments_A.push(r.id);
  } else if (list === 'attachments_listB') {
    removedAttachments_B.push(r.id);
  } else if (list === 'attachments_listC') {
    removedAttachments_C.push(r.id);
  }
  };

  handleRemoveImageA = (r, required) => {
    const { info, removedAttachments_A } = this.state;

    const res = info.attachments_listA.filter(e => e !== r);
    this.handleAnswerChanged('info', res, 'attachments_listA', required);
    removedAttachments_A.push(r.id);
  };

    handleRemoveImageC = (r, required) => {
      const { info, removedAttachments_C } = this.state;

      const res = info.attachments_listC.filter(e => e !== r);
      this.handleAnswerChanged('info', res, 'attachments_listC', required);
      removedAttachments_C.push(r.id);
    };

  handleRemoveImageB = (r, required) => {
    const { info, removedAttachments_B } = this.state;

    const res = info.attachments_listB.filter(e => e !== r);
    this.handleAnswerChanged('info', res, 'attachments_listB', required);
    removedAttachments_B.push(r.id);
  };

  getFileNames = async (count) => {
    const response = await GetFileName.getUploadFileName(count);
    return response;
  };

  doS3Upload = async (files, fileIds, entity) => {
    const { user: { portal_airport: { code, backend_id } } } = this.props;
    const upload = await S3Uploads.uploadFiles(files, fileIds.filename, entity, backend_id, code);
    return upload;
  };


  initialteApplication = async (draft) => {
    const { user: { portal_airport: { code, backend_id } }, user, actionInitiateApplication,
    actionRejectedApplicationInitiate, actionRenewApplication, schema } = this.props;
    const {
      fieldErrors,
      info,
      response: { ...form_data },
      multipleRemarks,
      requiredAttachments,
      felonyInvolvingRemarks,
      noneCheckbox,
      listAValues,
      listBValues,
      listCValues,
      agreements, removedAttachments_B, removedAttachments_A, fields, signatoryFieldErrors, signatoryResponse: { ...signatory_data },
      signatoryCustomFields, removedAttachments_C } = this.state;
    if (schema?.settings?.application_fill_up_privilege_type === 'signatory_staff' && info?.access_area?.length === 0) {
      this.setState({
        fieldErrors: {
          ...fieldErrors,
          access_area: true
        }
      });
      return;
    }
    const attachmentFields = fields.filter(schemaField => (
      schemaField?.type === 'attachments' && schemaField?.id !== 'attachmentslist_a' && schemaField?.id !== 'attachmentslist_b'
      && schemaField?.id !== 'attachmentslist_c'
    ));
    const signatoryAttachmentFields = signatoryCustomFields && signatoryCustomFields.filter(sig => sig.type === 'attachments');
    const signatorySignatureFields = signatoryCustomFields && signatoryCustomFields.filter(sig => sig.type === 'signature');
    const errors = { ...fieldErrors, ...signatoryFieldErrors };
    const formData = new FormData();
    let noErrors = Object.keys(errors).every(k => errors[k] === false);
    const data = { ...info };
    let access_area = Array.isArray(data.access_area)
    ? data.access_area.map(a => a.value || a)
    : typeof data.access_area === 'string' && data.access_area.length > 0
    ? data.access_area.split(',').map(a => a.trim())
    : [];
    let sub_access_areas = Array.isArray(data.sub_access_areas)
    ? data.sub_access_areas?.map(a => a.value || a)
    : typeof data.sub_access_areas === 'string' && data.sub_access_areas.length > 0
    ? data.sub_access_areas.split(',')?.map(a => a.trim())
    : [];
    const attachmentslistA = getField(fields, 'attachmentslist_a');
    const attachmentslistB = getField(fields, 'attachmentslist_b');
    const attachmentslistC = getField(fields, 'attachmentslist_c');

    const checkAddReqdocsA = attachmentslistA?.settings?.add_req_docs;
    const checkAddReqdocsB = attachmentslistB?.settings?.add_req_docs;
    const checkAddReqdocsC = attachmentslistC?.settings?.add_req_docs;

    if (draft === true) {
      data.draft = true;
      data.status = 3;
      info.status = 3;
      this.setState({ info });
      noErrors = true;
    } else {
      data.status = 0;
      info.status = 0;
      this.setState({ info });
    }
    if (noErrors) {
      this.setState({ loadingStatus: true });
      if (attachmentFields.length > 0) {
        for (let index = 0; index < attachmentFields.length; index++) {
          let attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments') {
            if (schemaField?.type === 'attachments' && form_data[attachmentField]?.length > 0) {
              const customAttachments = [];
              const attachmentIDs = [];
              form_data[attachmentField].forEach((e) => {
                if (!e.id) {
                  customAttachments.push(e);
                }
              });
              let fileIdsC = '';
              if (customAttachments?.length > 0) {
                // eslint-disable-next-line no-await-in-loop
                fileIdsC = await this.getFileNames(customAttachments?.length);
              }
              if (fileIdsC) {
                // eslint-disable-next-line no-await-in-loop
                await this.doS3Upload(customAttachments, fileIdsC, 'badgingCustomAttachments').then(
                  () => {
                    fileIdsC.filename.forEach((attachmentId) => {
                      if (attachmentId) {
                        attachmentIDs.push(attachmentId.toString());
                      }
                    });
                  }
                );
                data.airportCode = code;
              }
              form_data[attachmentField] = attachmentIDs;
            }
          }
        }
      }
      if (this.state.signatureFields.length > 0) {
        for (let i = 0; i < this.state.signatureFields.length; i++) {
          const signatureField = this.state.signatureFields[i];

          if (form_data[signatureField]) {
            const signatureData = [];
            // eslint-disable-next-line no-await-in-loop
            const fileIds = await this.getFileNames(1, [form_data[signatureField]], 'badging');

            if (fileIds) {
              // eslint-disable-next-line no-await-in-loop
              await this.doS3Upload([form_data[signatureField]], fileIds, 'badgingCustomSignatures');

              // only keep the UUIDs, not the raw file
              fileIds.filename.forEach((attachmentId) => {
                if (attachmentId) {
                  signatureData.push(attachmentId.toString());
                }
              });
              data.airportCode = code;
            }
            form_data[signatureField] = signatureData;
          }
        }
      }

      if (signatoryAttachmentFields && signatoryAttachmentFields.length > 0) {
        for (let index = 0; index < signatoryAttachmentFields.length; index++) {
          let sigAttachmentField = signatoryAttachmentFields[index]?.id;
          const sigSchemaField = signatoryAttachmentFields[index];
          if (sigSchemaField?.type === 'attachments') {
            if (sigSchemaField?.type === 'attachments' && signatory_data[sigAttachmentField]?.length > 0) {
              let attachmentIDs = [];
              const newAttachments = signatory_data[sigAttachmentField].filter(file => !file.id) || [];
              const oldAttachmentIds = signatory_data[sigAttachmentField].filter(file => file.id && file.file_name).map(file => file.attachment_id) || [];
              attachmentIDs = [...oldAttachmentIds];
              let fileIdsC = '';
              if (newAttachments?.length > 0) {
                // eslint-disable-next-line no-await-in-loop
                fileIdsC = await this.getFileNames(newAttachments?.length);
              }
              if (fileIdsC) {
                // eslint-disable-next-line no-await-in-loop
                await this.doS3Upload(newAttachments, fileIdsC, 'badgingCustomAttachments').then(
                  () => {
                    fileIdsC.filename.forEach((attachmentId) => {
                      if (attachmentId) {
                        attachmentIDs.push(attachmentId.toString());
                      }
                    });
                  }
                );
                data.airportCode = code;
              }
              signatory_data[sigAttachmentField] = attachmentIDs;
            }
          }
        }
      }
      if (signatorySignatureFields?.length > 0) {
        await Promise.all(
          signatorySignatureFields.map(async (signatureField) => {
            const fieldId = signatureField.id;
            const file = signatory_data[fieldId];

            if (!file) return;

            const signatureData = [];
            const files = Array.isArray(file) ? file : [file];

            const fileIds = await this.getFileNames(1, files, 'badging');

            if (fileIds?.filename?.length) {
              await this.doS3Upload(files, fileIds, 'badgingCustomSignatures');

              fileIds.filename.forEach((id) => {
                if (id) signatureData.push(id.toString());
              });

              data.airportCode = code;
            }

            signatory_data[fieldId] = signatureData;
          })
        );
      }
      data.phone_number = info.phone_number[0] + info.phone_number.slice(1).replace(/[^\d]/g, '');
      data.created_at = moment().format();
      data.installationId = backend_id;
      data.submitted_date = moment().format();
      delete data.attachments_listA;
      delete data.attachments_listB;
      delete data.attachments_listC;
      delete data.feet;
      delete data.inches;
      data.response = JSON.stringify(form_data);
      data.signatory_response= JSON.stringify(signatory_data);
      data.multipleRemarks = multipleRemarks;
      data.felonyInvolvingRemarks = felonyInvolvingRemarks;
      data.noneCheckbox = noneCheckbox;
      data.agreements = agreements;
      data.signatory_review = true;
      data.company_name = user.current_tenant?.id;
      data.access_area = access_area;
      data.sub_access_areas = sub_access_areas;
      data.application_filled_by = 'Signatory';
      if (draft === true) {
        data.draft = true;
        data.status = 3;
        info.status = 3;
        this.setState({ info });
      } else {
        data.status = 5;
        info.status = 5;
        this.setState({ info });
      }
      let newAttachmentsA = [];
      let newAttachmentsB = [];
      let newAttachmentsC = [];
      let oldAttachmentIdsA = [];
      let oldAttachmentIdsB = [];
      let oldAttachmentIdsC = [];
      if (info?.attachments_listA && info.attachments_listA?.length > 0) {
          newAttachmentsA = info.attachments_listA.filter(file => !file.id);
          oldAttachmentIdsA = info.attachments_listA.filter(file => file.id && file.file_name).map(file => file.attachment_id);
      }
      if (info?.attachments_listB && info.attachments_listB?.length > 0) {
          newAttachmentsB = info.attachments_listB.filter(file => !file.id);
          oldAttachmentIdsB = info.attachments_listB.filter(file => file.id && file.file_name).map(file => file.attachment_id);
      }
      if (info?.attachments_listC && info.attachments_listC?.length > 0) {
        newAttachmentsC = info.attachments_listC.filter(file => !file.id);
        oldAttachmentIdsC = info.attachments_listC.filter(file => file.id && file.file_name).map(file => file.attachment_id);
      }
      const forms_of_identification = { ...requiredAttachments };

      let fileIdsA = '';
      let fileIdsB = '';
      let fileIdsc = '';

      const processAttachments = async (list, attachments, value) => {
        const attachmentsIds = [];
        let fieldIds = {};

        await Promise.all(
          Object.keys(forms_of_identification[list]|| {}).map(async (eachRow) => {
            const { attachment, file_name, expiry_date } = forms_of_identification[list][eachRow];

            if (attachment?.length > 0) {
              const newAttachments = attachment.filter(file => !file.id);
              const oldAttachmentIds = attachment.filter(file => file.id && file.file_name).map(file => file.attachment_id);

              let fileIds = '';

              if (newAttachments.length>0) {
                attachments.push(...newAttachments);
                 fileIds = await this.getFileNames(newAttachments.length);
                 attachmentsIds.push(...(fileIds?.filename));
              }

                  forms_of_identification[list][eachRow] = {
                    file_name: value.find(eachKey => eachKey.key === file_name),
                    expiry_date,
                    attachment: oldAttachmentIds?.length>0 ? oldAttachmentIds : fileIds?.filename
                  };
            } else {
              forms_of_identification[list][eachRow] = {
                file_name: value.find(eachKey => eachKey.key === file_name),
                expiry_date,
                attachment: []
              };
            }
          })
        );

        fieldIds.filename = attachmentsIds;
        if (list === 'attachments_listA') {
            fileIdsA = fieldIds;
        }
        if (list === 'attachments_listB') {
          fileIdsB = fieldIds;
        }
        if (list === 'attachments_listC') {
          fileIdsc = fieldIds;
        }
    };

      if (checkAddReqdocsA) {
        await processAttachments('attachments_listA', newAttachmentsA, listAValues);
      } else {
        let attachmentsA = [];
        oldAttachmentIdsA.forEach((attachmentId) => {
          attachmentsA.push(attachmentId.toString());
        });
        form_data.attachments_listA = attachmentsA;
    }

      if (checkAddReqdocsB) {
        await processAttachments('attachments_listB', newAttachmentsB, listBValues);
      } else {
        let attachmentsB = [];
          oldAttachmentIdsB.forEach((attachmentId) => {
            attachmentsB.push(attachmentId.toString());
        });
          form_data.attachments_listB = attachmentsB;
      }

      if (checkAddReqdocsC) {
        await processAttachments('attachments_listC', newAttachmentsC, listCValues);
      } else {
        let attachmentsC = [];
          oldAttachmentIdsC.forEach((attachmentId) => {
            attachmentsC.push(attachmentId.toString());
        });
          form_data.attachments_listC = attachmentsC;
      }

      data.forms_of_identification = JSON.stringify({ ...forms_of_identification });

      if (!checkAddReqdocsA && newAttachmentsA?.length > 0) {
        fileIdsA = await this.getFileNames(newAttachmentsA?.length);
      }
      if (!checkAddReqdocsB && newAttachmentsB?.length > 0) {
        fileIdsB = await this.getFileNames(newAttachmentsB?.length);
      }
      if (!checkAddReqdocsC && newAttachmentsC?.length > 0) {
        fileIdsc = await this.getFileNames(newAttachmentsC?.length);
      }
      if (fileIdsA || fileIdsB || fileIdsc) {
        if (fileIdsA) {
          await this.doS3Upload(newAttachmentsA, fileIdsA, 'badging_A').then(
            () => {
              fileIdsA.filename.forEach((attachmentId) => {
                formData.append('attachments_listA', attachmentId.toString());
              });
            }
          );
          data.airportCode = code;
        }
        if (fileIdsB) {
          await this.doS3Upload(newAttachmentsB, fileIdsB, 'badging_B').then(
            () => {
              fileIdsB.filename.forEach((attachmentId) => {
                formData.append('attachments_listB', attachmentId.toString());
              });
            }
          );
          data.airportCode = code;
        }
        if (fileIdsc) {
          await this.doS3Upload(newAttachmentsC, fileIdsc, 'badging_C').then(
            () => {
              fileIdsc.filename.forEach((attachmentId) => {
                formData.append('attachments_listC', attachmentId.toString());
              });
            }
          );
          data.airportCode = code;
        }
      }
      if (
        'removedAttachments' in info
        && info?.removedAttachments?.length > 0
      ) {
        data.removedAttachments = info.removedAttachments;
      } else {
        Object.keys(data).forEach((k) => {
          formData.append(k, data[k]);
        });
        if (removedAttachments_A?.length > 0) {
          removedAttachments_A.forEach(e => formData.append('removedAttachments_A', e));
        }
        if (removedAttachments_B?.length > 0) {
          removedAttachments_B.forEach(e => formData.append('removedAttachments_B', e));
        }
        if (removedAttachments_C?.length > 0) {
          removedAttachments_C.forEach(e => formData.append('removedAttachments_C', e));
        }
        if (this.state.reOpenId !== undefined) {
          if (this.state.reOpenData && this.state.reOpenData.application_filled_by === 'Signatory' && this.state.reOpenData.status === 7) {
            actionRenewApplication(this.state.reOpenId, formData);
          } else {
            actionRejectedApplicationInitiate(this.state.reOpenId, formData);
          }
        } else {
        actionInitiateApplication(formData);
        }
      }
    } else {
      this.setState({ showFormErrors: true });
    }
  };

  next = () => {
    const { fieldErrors, response, info, fields, requiredAttachmentsErrors } = this.state;
    const { schema } = this.props;
    if (response.nation_of_citizenship?.value === 'US') {
      this.setState({
        fieldErrors: {
          ...fieldErrors,
          nation_of_citizenship: false,
          alien_registration_number: false,
          passport: false,
          passport_country: false
        }
      });
    }
    const listA = getField(fields, 'attachmentslist_a');
    const listB = getField(fields, 'attachmentslist_b');
    const listC = getField(fields, 'attachmentslist_c');

    const dob_setting = fields?.filter(field => field.id === 'date_of_birth');
    const country = fields.filter(field => field.id === 'country');
    if (country.length > 0 && !country[0]?.isDisabled) {
      this.setState({
        fieldErrors: {
          ...this.state.fieldErrors,
          country: false
        }
      });
    }
    let reqAttachmentListAError = true;
    let reqAttachmentListBError = true;
    let reqAttachmentListCError = true;

    const checkReqAttachementError = list => Object.values(requiredAttachmentsErrors[list]).every(row => Object.values(row).every(value => value === false));
    let newDate = moment().startOf('day');
    let noErrors = Object.keys(fieldErrors).every(
      k => fieldErrors[k] === false
    );
    let dateOfBirth = moment(response?.date_of_birth);
    let age = newDate.diff(dateOfBirth, 'year', true);
    if (!listA?.isDisabled && listA?.required) {
      if (!listA?.settings?.add_req_docs && info?.attachments_listA?.length === 0) {
       this.setState({ attachmentslist_a: true, showFormErrors: true });
       return;
     }
   }

   if (!listB?.isDisabled && listB?.required) {
     if (!listB?.settings?.add_req_docs && info?.attachments_listB?.length === 0) {
      this.setState({ attachmentslist_b: true, showFormErrors: true });
      return;
    }
  }

  if (!listC?.isDisabled && listC?.required) {
     if (!listC?.settings?.add_req_docs && info?.attachments_listC?.length === 0) {
      this.setState({ attachmentslist_c: true, showFormErrors: true });
      return;
    }
  }

  if (listA && !listA?.isDisabled &&listA?.required && listA?.settings?.add_req_docs) {
    reqAttachmentListAError = checkReqAttachementError('attachments_listA');
  }

  if (listB && !listB?.isDisabled && listB?.required && listB?.settings?.add_req_docs) {
    reqAttachmentListBError = checkReqAttachementError('attachments_listB');
  }

  if (listC && !listC?.isDisabled && listC?.required && listC?.settings?.add_req_docs) {
    reqAttachmentListCError = checkReqAttachementError('attachments_listC');
  }

    if ((dob_setting && Object.keys(dob_setting).length > 0 && !dob_setting[0]?.isDisabled) && (response?.date_of_birth && age <= 18)) {
      this.setState({
        ...this.state,
        dateError: 'Applicant age should be 18 years or above.',
        showFormErrors: true
      });
      return;
    }
    if (schema?.settings?.application_fill_up_privilege_type === 'signatory_staff' && info?.access_area?.length === 0) {
      this.setState({
        accessAreaError: true,
        showFormErrors: true
      });
      return;
    }

    if (noErrors) {
      if (reqAttachmentListAError && reqAttachmentListBError && reqAttachmentListCError) {
        noErrors = true;
      } else {
        noErrors = false;
      }
    }

    if (noErrors) {
      this.setState({
        showFormErrors: false,
        response: { ...response },
        fieldErrors: {
          ...fieldErrors
        },
        emsg: false,
        dateError: '',
        accessAreaError: false
      });
      this.initialteApplication();
    } else {
      this.setState({ showFormErrors: true, dateError: false, accessAreaError: false });
    }
  };

  render() {
    const {
      info,
      requiredMap,
      showFormErrors,
      response,
      loadingStatus,
      fieldErrors,
      emsg,
      listAError,
      listBError,
      listAMessage,
      listBMessage,
      listCMessage,
      listAValues,
      listBValues,
      listCValues,
      requiredAttachments,
      requiredAttachmentsErrors,
      applicantAcknowldgementMessage,
      dateError,
      reOpenData,
      signatoryRequiredMap,
      signatoryResponse,
      signatoryFieldErrors,
      accessAreaError
    } = this.state;
    const { schema, user, privileges } = this.props;
    const newSchema = schema?.schema?.schema?.fields?.map((item) => {
      const data = item;
      if (item.id === 'employer') {
        data.disable = true;
      }
      return data;
    });
    const aid = user?.airport?.code;
    const companyName=[user?.current_tenant];
    return (
      <>
        <Loading loadingStatus={loadingStatus} />
        <SectionHeader
          icon={icon}
          translationID="topbar.badging"
          defaultTitle="Badges"
        />
        <HeaderBack
          translationID="workorder.settings.back"
          translationDefault="Back"
          backRoute="/badging/select"
        />

        <Suspense fallback={<Loading loadingStatus />}>
          <div className={styles.form}>
            <Panel
              title="badge.create.Applications"
              defaultTitle={reOpenData && reOpenData?.status === 7 ? 'Renewal Badge Application' : 'New Badge Application'}
              containerClasses="mb-5"
            >
              <div className={`${styles.content} ${styles.embedded}`}>
                <SignatoryField
                  goToNext={this.next}
                  info={info}
                  handleAnswerChanged={this.handleAnswerChanged}
                  handleFieldErrorChanged={this.handleFieldErrorChanged}
                  requiredMap={requiredMap}
                  fields={newSchema}
                  response={response}
                  listAError={listAError}
                  listBError={listBError}
                  handleAddmore={this.handleAddmore}
                  requiredAttachments={requiredAttachments || {}}
                  requiredAttachmentsErrors={requiredAttachmentsErrors || {}}
                  listAValues={listAValues}
                  listBValues={listBValues}
                  listCValues={listCValues}
                  handleRemoveImage={this.handleRemoveImage}
                  handleDropList={this.handleDropList}
                  handleDropListA={this.handleDropListA}
                  handleDropListB={this.handleDropListB}
                  handleDropListC={this.handleDropListC}
                  handleRemoveImageA={this.handleRemoveImageA}
                  handleRemoveImageB={this.handleRemoveImageB}
                  handleRemoveImageC={this.handleRemoveImageC}
                  showFormErrors={showFormErrors}
                  fieldErrors={fieldErrors}
                  aid={aid}
                  schemaSettings={schema?.settings}
                  listAMessage={listAMessage}
                  listBMessage={listBMessage}
                  listCMessage={listCMessage}
                  applicantAcknowldgementMessage={applicantAcknowldgementMessage}
                  tenantName={companyName}
                  settings={schema}
                  handleUploadAttachments={this.handleUploadAttachments}
                  privilegesData={privileges}
                  signatoryRequiredMap={signatoryRequiredMap}
                  signatoryCustomFields={schema?.signatory_fields_schema?.schema?.fields}
                  signatoryResponse={signatoryResponse}
                  signatoryFieldErrors={signatoryFieldErrors}
                  accessAreaError={accessAreaError}
                />
                <h5 className="text-danger text-center mb-0 mt-0">{emsg}</h5>
                <div
                  className={styles.footer}
                  style={{ justifyContent: 'flex-end', padding: '0' }}
                >
                  <p className="text-danger text-center mb-0 mt-0 mr-4">
                    {dateError}
                  </p>
                  <Button
                    action="secondary"
                    onClick={this.next}
                    translationID="wildlife.form.1"
                    defaultText="Submit"
                  />
                </div>
              </div>
            </Panel>
          </div>
        </Suspense>
      </>
    );
  }
}

SignatoryApplication.propTypes = {
  match: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  user: state.auth.profile,
  schema: state.badging.schema,
  users: state.inspection.userlist,
  saveAction: state.badging.InitiateApplicationAction,
  errormsg: state.badging.errormsg,
  application: state.badging.applicationdata,
  fetchApplicationAction: state.badging.fetchApplicationAction,
  ReApplicationAction: state.badging.ReApplicationAction,
  action: state.badging.action,
  privileges: state.badging.accessAreas,
  RenewalApplicationAction: state.badging.RenewalApplicationAction
});
const mapDispatchToProps = dispatch => ({
  actionFetchSchema: () => {
    dispatch(getSchema());
  },
  actionInitiateApplication: (query) => {
    dispatch(initiateApplication(query));
  },
  clearApplicationList: () => {
    dispatch(clearApplicationDetails());
  },
  actionReopenDetail: (id) => {
    dispatch(getApplication(id));
  },
  actionRejectedApplicationInitiate: (id, data) => {
    dispatch(badgeReapply(id, data));
  },
  actionFetchPrivileges: () => {
    dispatch(getAccessAreas());
  },
  actionRenewApplication: (id, data) => {
    dispatch(renewApplication(id, data));
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(injectIntl(withRouter(SignatoryApplication))));
